import { create } from 'zustand';

type WarningsState = {
  codesMissingMapping: string[];
  settlementLabelsMissingInMappings: string[];
  settlementVarietiesOutsideSpecies: string[];
  /** Receiver cost names without an exporter cost category (flagged exporters). */
  unclassifiedExporterCostsCount: number;
  bannersVisible: boolean;
  setWarnings: (warnings: {
    codesMissingMapping: string[];
    settlementLabelsMissingInMappings: string[];
    settlementVarietiesOutsideSpecies?: string[];
  }) => void;
  setUnclassifiedExporterCostsCount: (count: number) => void;
  setBannersVisible: (visible: boolean) => void;
  toggleBannersVisible: () => void;
  clearWarnings: () => void;
};

const useWarningsStore = create<WarningsState>((set) => ({
  codesMissingMapping: [],
  settlementLabelsMissingInMappings: [],
  settlementVarietiesOutsideSpecies: [],
  unclassifiedExporterCostsCount: 0,
  bannersVisible: true,
  setWarnings: ({
    codesMissingMapping,
    settlementLabelsMissingInMappings,
    settlementVarietiesOutsideSpecies,
  }) =>
    set((state) => ({
      codesMissingMapping,
      settlementLabelsMissingInMappings,
      settlementVarietiesOutsideSpecies:
        settlementVarietiesOutsideSpecies ??
        state.settlementVarietiesOutsideSpecies,
    })),
  setUnclassifiedExporterCostsCount: (count) =>
    set({ unclassifiedExporterCostsCount: count }),
  setBannersVisible: (visible) => set({ bannersVisible: visible }),
  toggleBannersVisible: () =>
    set((state) => ({ bannersVisible: !state.bannersVisible })),
  clearWarnings: () =>
    set({
      codesMissingMapping: [],
      settlementLabelsMissingInMappings: [],
      settlementVarietiesOutsideSpecies: [],
    }),
}));

export default useWarningsStore;
